import React from 'react';
import HomeCourse from './HomeCourse';
import OtherCourses from './OtherCourses';

export default React.createClass({
    propTypes: {
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object,
        leadingCoursesUrl: React.PropTypes.string,
        courseDetailsUrl: React.PropTypes.string
    },
    getInitialState() {
        return {
            loading: true,
            error: false,
            data: []
        };
    },
    componentWillMount() {
        this.serverRequest = $.get(this.props.urls.get, (result) => {
            this.setState({
                loading: false,
                data: result
            });
        }).fail(() => {
            alert(this.props.i18n.error);
            this.setState({
                loading: false,
                error: true
            });
        });
    },
    componentWillUnmount: function() {
        this.serverRequest.abort();
    },
    handleRemoveCourse(id) {
        var data = this.state.data;
        data.OtherCourses = _.reject(this.state.data.OtherCourses, { 'Id': id });

        this.setState({
            data: data
        });
    },
    render() {
        if (this.state.loading) {
            return (
                <div>
                    <div className="c-spinner">{this.props.i18n.loading}</div>
                </div>
            );
        } else if (!this.state.data) {
            return (
                <div>
                    {this.props.i18n.error}
                </div>
            );
        } else {
            return (
                <div className="c-courses">
                    <div className="c-module-header">{this.props.i18n.homeCourse}</div>
                    {<HomeCourse
                        data={this.state.data.HomeCourse}
                        i18n={this.props.i18n}
                        homeCourse={true}
                        leadingCoursesUrl={this.props.leadingCoursesUrl}
                        courseDetailsUrl={this.props.courseDetailsUrl}
                    />}
                    <div className="c-module-header c-module-header--seperated">{this.props.i18n.otherCourses}</div>
                    {<OtherCourses
                        data={this.state.data.OtherCourses}
                        urls={this.props.urls}
                        i18n={this.props.i18n}
                        onRemove={this.handleRemoveCourse}
                        leadingCoursesUrl={this.props.leadingCoursesUrl}
                        courseDetailsUrl={this.props.courseDetailsUrl}
                    />}
                </div>
            );
        }
    }
});
